import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Textarea extends PureComponent {
    render() {
        const {
            inputRef,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['form-control']: true
        });

        return (
            <textarea ref={inputRef} className={classNames} {...props} cols="4" />
        );
    }
}

Textarea.defaultProps = {};

export default Textarea;
